const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const Scratch3LooksBlocks = require('../../blocks/scratch3_looks');
const uid = require('../../util/uid');
const menuIconURI = "data:image/png;base64,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"


class PythonStatementsBlocks {
    constructor(runtime) {
        if (!runtime) {
            throw new Error('Runtime is required for PythonStatementsBlocks');
        }
        this.runtime = runtime;

        // Bind methods to this instance
        this._onResetStatements = this._onResetStatements.bind(this);
        this._onTargetWillExit = this._onTargetWillExit.bind(this);
        this._updateStatement = this._updateStatement.bind(this);

        // Reset all statements on start/stop
        this.runtime.on('PROJECT_STOP_ALL', this._onResetStatements);
        this.runtime.on('targetWasRemoved', this._onTargetWillExit);

        // Enable other blocks to use statements like print/input
        this.runtime.on(PythonStatementsBlocks.PRINT_OR_INPUT, this._updateStatement);
    }

    static get DEFAULT_STATEMENT_STATE() {
        return {
            text: '',
            type: 'print',
            usageId: null
        };
    }

    getInfo() {
        return {
            id: "pythonStatements",
            color1: '#008080',
            name: "Python Statements",
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: "python_print",
                    blockType: BlockType.COMMAND,
                    text: "print ([MESSAGE])",
                    arguments: {
                        MESSAGE: {
                            type: ArgumentType.STRING,
                            defaultValue: "Hello, World!"
                        }
                    }
                },
                {
                    opcode: "python_input",
                    blockType: BlockType.REPORTER,
                    text: "input ([PROMPT])",
                    arguments: {
                        PROMPT: {
                            type: ArgumentType.STRING,
                            defaultValue: "Enter something:"
                        }
                    }
                },
                {
                    opcode: "python_type",
                    blockType: BlockType.REPORTER,
                    text: "type ([VALUE])",
                    arguments: {
                        VALUE: {
                            type: ArgumentType.STRING,
                            defaultValue: "example"
                        }
                    }
                },
                {
                    opcode: 'calculate',
                    blockType: BlockType.REPORTER,
                    text: '[int1] [operation] [int2]',
                    arguments: {
                        operation: {
                            type: ArgumentType.STRING,
                            menu: 'operationsMenu'
                        },
                        int1: {
                            type: ArgumentType.NUMBER
                        },
                        int2: {
                            type: ArgumentType.NUMBER
                        }
                    }
                },
                {
                    opcode: "clear_print",
                    blockType: BlockType.COMMAND,
                    text: "clear_print ( )",
                },
            ],
            menus: {
                operationsMenu: {
                    acceptReporters: false,
                    items: [
                        {
                            text: '+',
                            value: 'add'
                        },
                        {
                            text: '-',
                            value: 'subtract'
                        },
                        {
                            text: '*',
                            value: 'multiply'
                        },
                        {
                            text: '/',
                            value: 'divide'
                        },
                        {
                            text: '%',
                            value: 'remainder'
                        }
                    ]
                },
            }
        };
    }

    python_print(args, util) {
        let message;

        // Special handling for loop variables
        if (args.MESSAGE === 'i' && util.thread.currentLoopValue !== undefined) {
            message = util.thread.currentLoopValue;
        }
        // Regular handling for other cases
        else if (typeof args.MESSAGE === 'object') {
            if (args.MESSAGE.type === ArgumentType.VARIABLE) {
                const variable = util.target.lookupVariableById(args.MESSAGE.id);
                message = variable ? variable.value : '';
            } else if (args.MESSAGE.id) {
                const variable = util.target.lookupVariableById(args.MESSAGE.id);
                message = variable ? variable.value : '';
            } else {
                message = args.MESSAGE.toString();
            }
        } else {
            message = Cast.toString(args.MESSAGE);
        }

        // Emit the print event for any listeners
        this.runtime.emit('PRINT_MESSAGE', message);

        // Display the message using the say bubble
        this.runtime.emit(Scratch3LooksBlocks.SAY_OR_THINK, util.target, 'say', message);
        
        // Log to console for debugging
        console.log('python_print:', message);
    }

    python_input(args, util) {
        // Simulate input by returning a fixed value or using a prompt
        return prompt(Cast.toString(args.PROMPT));
    }

    python_type(args, util) {
        const value = args.VALUE;

        if (typeof value === 'string') {
            if ((value.startsWith('"') && value.endsWith('"')) ||
                (value.startsWith("'") && value.endsWith("'"))) {
                    return 'str';
                } else {
                     if ((value.toLowerCase() === 'true') || (value.toLowerCase() === 'false')) return 'bool';
                     else if (!isNaN(value)) {
                        return value.includes('.') ? 'float' : 'int';
                    } else {
                        return 'str';
                    }
            }
        } else if (typeof value === 'number') {
            return Number.isInteger(value) ? 'int' : 'float';
        } else if (typeof value === 'boolean') {
            return 'bool';
        } else if (Array.isArray(value)) {
            return 'list';
        } else {
            return 'NoneType';
        }
    }

    _updateStatement(target, type, text) {
        const statementState = this._getStatementState(target);
        statementState.type = type;
        statementState.text = text;
        statementState.usageId = uid();
    }

    _getStatementState(target) {
        if (!target.statementState) {
            target.statementState = Object.assign({}, PythonStatementsBlocks.DEFAULT_STATEMENT_STATE);
        }
        return target.statementState;
    }

    _onResetStatements() {
        // Logic to reset statements
    }

    _onTargetWillExit(target) {
        // Logic to handle target exit
    }

    calculate(args) {
        const num1 = parseFloat(args.int1);
        const num2 = parseFloat(args.int2);
        switch (args.operation) {
            case 'add':
                return num1 + num2;
            case 'subtract':
                return num1 - num2;
            case 'multiply':
                return num1 * num2;
            case 'divide':
                return num1 / num2;
            case 'remainder':
                return num1 % num2;    
            default:
                return 0;
        }
    }

    clear_print(args, util) {
        this.runtime.emit(Scratch3LooksBlocks.SAY_OR_THINK, util.target, 'say', '');
    }
}

module.exports = PythonStatementsBlocks;